import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Post {
  id: string;
  title: string;
  slug: string;
  excerpt: string | null;
  subtitle: string | null;
  cover_image: string | null;
  status: 'draft' | 'published';
  is_featured: boolean;
  display_order: number;
  published_at: string | null;
  created_at: string;
  updated_at: string;
  topic_id: string | null;
  header_tone: 'light' | 'dark';
  related_article_1_id: string | null;
  related_article_2_id: string | null;
  related_article_3_id: string | null;
}

export function usePosts(statusFilter?: 'draft' | 'published' | 'all') {
  return useQuery({
    queryKey: ['posts', statusFilter],
    queryFn: async () => {
      let query = supabase
        .from('posts')
        .select('id, title, slug, excerpt, subtitle, cover_image, status, is_featured, display_order, published_at, created_at, updated_at, topic_id, header_tone')
        .order('created_at', { ascending: false });

      if (statusFilter && statusFilter !== 'all') {
        query = query.eq('status', statusFilter);
      }

      const { data, error } = await query;

      if (error) throw error;
      return data as Post[];
    },
    staleTime: 30000,
    refetchOnWindowFocus: false,
  });
}

export function usePublishedPosts() {
  return useQuery({
    queryKey: ['posts', 'published-ordered'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('posts')
        .select('id, title, slug, excerpt, subtitle, cover_image, status, is_featured, display_order, published_at, created_at, updated_at, topic_id, header_tone')
        .eq('status', 'published')
        .order('display_order', { ascending: true });

      if (error) throw error;
      return data as Post[];
    },
    staleTime: 30000,
    refetchOnWindowFocus: false,
  });
}
